/*
 * Copyright © Siemens 2026
 */

import { Routes } from '@angular/router';
import { createUserGuard } from './core/auth/guard/auth.guard';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('./features/landing/landing').then(m => m.default),
        pathMatch: 'full',
    },
    {
        path: 'auth',
        loadChildren: () => import('./features/auth/auth.routes').then(m => m.AuthRoutes),
    },
    {
        // Publishing section: software, revisions, artifacts (all authenticated users with any role)
        path: 'publishing',
        data: { breadcrumb: 'Publishing' },
        loadChildren: () => import('./features/publishing/publishing.routes').then(m => m.PublishingRoutes),
        canActivate: [createUserGuard(['PUBLISHER', 'MANAGER', 'ADMIN'])],
    },
    {
        // Access Management section: authorities, grants (MANAGER and ADMIN only)
        path: 'access-management',
        data: { breadcrumb: 'Access Management' },
        loadChildren: () => import('./features/publishing/access-management.routes').then(m => m.AccessManagementRoutes),
        canActivate: [createUserGuard(['MANAGER', 'ADMIN'])],
    },
];
